import {SvgIconData} from '@shared_web/components/core/svg_icon';

export const icon_search_white: SvgIconData = {
  viewBox: '0 0 20 20',
  element: (
    <path
      d="M19 19L13 13M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8Z"
      stroke="white"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
};
